import React, { useEffect, useState } from "react";
import { Container, ModalDialog } from "../../../components";
import { Icon, Text, Heading } from "@telia/teddy";
import { connect, useDispatch } from "react-redux";
import { FORM_ID } from "../../../../../constants";
import Pages from "../../../../../constants/pages";
import { RootState, Form } from "../../../../../models";
import { selectors as AUTH_SELECTORS } from "../../../authentication";
import AnnouncementText from "../../../checkout/components/atoms/AnnouncementText/AnnouncementText";
import BankIdSection from "../../../checkout/components/molecules/BankIdSectionTeliaBroker/BankIdSectionTeliaBroker";
import { resetOrder } from "../../../checkout/state/actions/phoneNumberActions";
import { setTransferOwnerPersonalDetails } from "../../../checkout/state/actions/transferOwnershipActions";
import { getLegalOwnerFullName } from "../../../checkout/state/selectors/customerInfoSelectors";
import { getFormById } from "../../../checkout/state/selectors/formSelectors";
import { successfullySetPersonalDetails } from "../../../checkout/state/selectors/verificationSelectors";
import { Input } from "../../../forms";
import { RapidForm } from "../../../rapidform";
import { VALIDATION_FIELD } from "../../../rapidform/formValidation";
import TEXT from "../../text-consts";
import "./ConfirmId.less";

interface StateProps {
    hasBankIdError: boolean;
    isBankIdVerified: boolean;
    legalOwnerFullName: string;
    successfullySetTransferOwnerDetails: boolean;
    transferOwnershipForm: Form;
}

type ConfirmIdProps = StateProps;
const ConfirmId: React.FC<ConfirmIdProps> = ({
    // Redux (data),
    legalOwnerFullName,
    transferOwnershipForm,
    successfullySetTransferOwnerDetails,
    hasBankIdError,
    isBankIdVerified,
}) => {
    const [showLogOutBankIdModal, setShowLogoutBankIdModal] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (successfullySetTransferOwnerDetails) {
            window.location.assign(Pages.TRANSFER_OWNERSHIP.CONFIRM_NUMBER.URL);
        }
    });

    const referer = "tlo";

    return (
        <Container className="confirm-id" size="medium" noMargin>
            {legalOwnerFullName && isBankIdVerified && !hasBankIdError && (
                <>
                    <Heading as="h2" mb="100" variant="title-200">
                        {TEXT.CONFIRM_ID.BANK_ID_VERIFIED.HEADING}
                    </Heading>
                    <div className="confirm-id__legalinfo">
                        <Text mb="100" data-di-mask variant="preamble-200">
                            {legalOwnerFullName}
                        </Text>
                        <div className="confirm-id__bankid-btn">
                            <button className="confirm-id__bankid-btn" onClick={() => setShowLogoutBankIdModal(true)}>
                                {TEXT.CONFIRM_ID.RESET_BANKID}
                                <Icon className="confirm-id__bankid-icon" name="logout" />
                            </button>
                        </div>
                        {showLogOutBankIdModal && (
                            <ModalDialog
                                className="confirm-id__logout-bankid"
                                size="small"
                                submitText="Ja, logg meg ut"
                                closeText="Nei, bli på siden"
                                closeKind="secondary"
                                heading="Ønsker du å logge ut av BankID?"
                                name="log-out-bank-id-modal"
                                onSubmit={() => {
                                    dispatch(resetOrder());
                                    setShowLogoutBankIdModal(false);
                                }}
                                onClose={() => setShowLogoutBankIdModal(false)}
                            ></ModalDialog>
                        )}
                    </div>
                    <RapidForm
                        id={FORM_ID.TRANSFER_OWNERSHIP}
                        action={"#"}
                        errors={transferOwnershipForm.errors}
                        values={transferOwnershipForm.values}
                        visible={transferOwnershipForm.visible}
                        started={transferOwnershipForm.started}
                        onSubmit={() => dispatch(setTransferOwnerPersonalDetails())}
                    >
                        <Text mb="100" variant="additional-100">
                            Du som ny eier må registere følgende kontaktinformasjon:
                        </Text>
                        <div className="confirm-id__input-wrapper" data-cy="confirm-id-input-wrapper">
                            <Input
                                type="tel"
                                name={VALIDATION_FIELD.PHONE}
                                label={"Telefonnummer"}
                                placeholder="12345678"
                                data-di-mask
                                className="confirm-id__input"
                            />
                            <Input
                                type="email"
                                name={VALIDATION_FIELD.EMAIL}
                                label={"E-post"}
                                placeholder="ola@nordmann.no"
                                data-di-mask
                                className="confirm-id__input"
                            />
                        </div>
                    </RapidForm>
                </>
            )}

            {!legalOwnerFullName && (!isBankIdVerified || hasBankIdError) && (
                <>
                    <Heading mb="100" as="h2" variant="title-200">
                        {TEXT.CONFIRM_ID.HEADING}
                    </Heading>
                    <AnnouncementText typeId="tlo_bankid" />
                    <Text mb="100" variant="additional-100">
                        {TEXT.CONFIRM_ID.BANKID_DESCRIPTION}
                        <br />
                        {TEXT.CONFIRM_ID.CREDIT_CHECK_DESCRIPTION}
                    </Text>
                    <BankIdSection referer={referer} />
                </>
            )}
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    legalOwnerFullName: getLegalOwnerFullName(state),
    transferOwnershipForm: getFormById(state, FORM_ID.TRANSFER_OWNERSHIP),
    successfullySetTransferOwnerDetails: successfullySetPersonalDetails(state),
    isBankIdVerified: AUTH_SELECTORS.isBankIdVerified(state),
    hasBankIdError: AUTH_SELECTORS.hasBankIdError(state),
});

export default connect(mapStateToProps)(ConfirmId);
